import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../../utils/helper.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { MachineProfile } from "../../../api/machine_profile.js";
import ConfirmationDlg from "../../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import ImageViewer from "../../../components/ImageViewer";
import { assets } from "./data";
import { QRCode } from "react-qrcode-logo";

function MachineList() {
  const [datas, setDatas] = useState(assets);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();

  const columns = [
    {
      name: "Asset ID",
      selector: (row) => row["Asset ID"],
      minWidth: "250px",
      maxWidth: "250px",
    },
    {
      name: "Asset Name",
      selector: (row) => row["Description"],

      minWidth: "200px",
      maxWidth: "250px",
    },
    {
      name: "Category",
      selector: (row) => row["Group"],
      minWidth: "180px",
      maxWidth: "180px",
    },
    {
      name: "Machine Health",
      selector: (row) => row["Machine Health"],
      minWidth: "200px",
      maxWidth: "250px",
    },
  ];
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-9">
                <div>
                  Asset ID : <b>{data["Asset ID"]}</b>
                </div>
                <div>
                  Asset Name : <b>{data["Description"]}</b>
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    navigate("/machine-asset/rul-detail/" + data["Asset ID"])
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">ASSET RUL</li>
          </ul>

          <h1 className="page-header">Asset Remaining Useful Life</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
